<!-- Divider -->
<div
  class="fuse-vertical-navigation-item-wrapper divider"
  [ngClass]="item().classes?.wrapper"
></div>
